/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Dropdown, Menu, Skeleton } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { getTasks } from '@store/Actions/GetTasks';
import { RootState } from '@store/index';
import UpdateTask from '@components/UpdateTask';
import CardFilter from '@components/CardFilter';
import NoResults from '@assets/icons/no-results.png';
import { useShowItem } from '../../hooks/useShow';

interface IProps {
    getTasks: () => void;
    tasks: any;
    loading: boolean;
    taskCard: [];
}

interface ITask {
    taskConfId: number;
    description: string;
    taskConfName: string;
    duration: number;
    isCompleted: number;
    isOnTime: number;
    isNew: number;
    createdDate: number;
    finishedDate: number;
    tasks: [
        {
            userName: string;
            userLastName: string;
            taskConfId: number;
            userId: number;
            createdDate: number;
            finishedDate: number;
            isCompleted: number;
            isOnTime: number;
            isNew: number;
            taskId: number;
            franchiseId: number;
            franchiseName: string;
            taskConfName: string;
            description: string;
            duration: number;
            fieldId: number;
            inputTypeId: number;
            inputName: string;
            isRequired: number;
            min: number;
            max: number;
            fieldName: string;
            value: string | null;
        },
    ];
    nameComplete: string;
    status: string;
    key: number;
}

const TaskCard: React.FC<IProps> = ({
    getTasks,
    tasks,
    loading,
    taskCard,
}): JSX.Element => {
    const { show, handleChange } = useShowItem();

    const franchiseId = Cookies.get('franchiseId');
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [query, setQuery] = useState<string>('');
    const [data, setData] = useState<ITask[]>([]);
    //need ITask
    const [rowData, setRowData] = useState<ITask>({
        taskConfId: 0,
        description: '',
        taskConfName: '',
        duration: 0,
        isCompleted: 0,
        isOnTime: 0,
        isNew: 0,
        createdDate: 0,
        finishedDate: 0,
        tasks: [
            {
                userName: '',
                userLastName: '',
                taskConfId: 0,
                userId: 0,
                createdDate: 0,
                finishedDate: 0,
                isCompleted: 0,
                isOnTime: 0,
                isNew: 0,
                taskId: 0,
                franchiseId: 0,
                franchiseName: '',
                taskConfName: '',
                description: '',
                duration: 0,
                fieldId: 0,
                inputTypeId: 0,
                inputName: '',
                isRequired: 0,
                min: 0,
                max: 0,
                fieldName: '',
                value: '',
            },
        ],
        nameComplete: '',
        status: '',
        key: 0,
    });

    useEffect(() => {
        getTasks();
    }, []);

    const closeModal = () => {
        setModalVisible(false);
    };

    const menu = (task: ITask) => (
        <Menu onClick={() => {}} key={task.tasks[0].taskId}>
            <Menu.Item key="0">
                <a onClick={() => handleUpdate(task)}>Editar</a>
            </Menu.Item>
        </Menu>
    );

    const handleUpdate = (task: ITask) => {
        setModalVisible(true);
        setRowData(task);
    };

    const searchFilter = (search) => {
        setQuery(search);

        const searchResult = taskCard.filter(
            (query: ITask) =>
                query.nameComplete
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                query.taskConfName
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                query.description
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                query.status.toLowerCase().includes(search.toLowerCase()),
        );

        if (search.length > 0) {
            setData(searchResult);
        } else {
            setData(taskCard);
        }
    };

    return (
        <div>
            {loading ? (
                <>
                    <Card loading={loading} style={{ marginBottom: '1.5em' }} />
                    <Card loading={loading} style={{ marginBottom: '1.5em' }} />
                    <Card loading={loading} />
                </>
            ) : (
                <>
                    <div
                        style={{
                            marginBottom: '1em',
                        }}
                    >
                        <CardFilter
                            query={query}
                            changeQuery={searchFilter}
                            placeholder="Filtrar por nombre, colaborador, descripcion o estado"
                        />
                    </div>
                    {data.length !== 0 ? (
                        data.map((task: any, idx) => (
                            <Card
                                style={{ marginBottom: '1.5em' }}
                                key={task.taskConfId}
                                size="small"
                                extra={
                                    <Dropdown
                                        overlay={() => menu(task)}
                                        trigger={['click']}
                                    >
                                        <a onClick={(e) => e.preventDefault()}>
                                            <MoreOutlined />
                                        </a>
                                    </Dropdown>
                                }
                            >
                                <Skeleton loading={loading} active>
                                    <Card
                                        size="small"
                                        type="inner"
                                        title="Nombre"
                                        bordered={false}
                                    >
                                        {task.taskConfName}
                                    </Card>
                                    <Card
                                        size="small"
                                        type="inner"
                                        title="Descripción"
                                        bordered={false}
                                    >
                                        {task.description}
                                    </Card>
                                    <Card
                                        size="small"
                                        type="inner"
                                        title="Usuario"
                                        bordered={false}
                                    >
                                        {task.nameComplete}
                                    </Card>
                                    <Card
                                        size="small"
                                        type="inner"
                                        title="Estado"
                                        bordered={false}
                                    >
                                        {task.status}
                                    </Card>
                                    <Button
                                        block
                                        ghost
                                        type="primary"
                                        onClick={() =>
                                            handleChange(idx, !show[idx])
                                        }
                                    >
                                        {show[idx]
                                            ? 'Ocultar detalles'
                                            : 'Ver mas detalles'}
                                    </Button>
                                    {task.tasks.map((element, index) => (
                                        <Fragment key={index}>
                                            {show[idx] && (
                                                <>
                                                    <Card
                                                        size="small"
                                                        type="inner"
                                                        title="Campo"
                                                        style={{
                                                            marginTop: '1em',
                                                        }}
                                                    >
                                                        {element.fieldName}
                                                    </Card>
                                                    <Card
                                                        size="small"
                                                        type="inner"
                                                        title="Tipo de campo"
                                                    >
                                                        {element.inputName}
                                                    </Card>
                                                    <Card
                                                        size="small"
                                                        type="inner"
                                                        title="Campo"
                                                    >
                                                        {element.franchiseName}
                                                    </Card>
                                                </>
                                            )}
                                        </Fragment>
                                    ))}
                                </Skeleton>
                            </Card>
                        ))
                    ) : (
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <img
                                src={NoResults}
                                style={{
                                    height: 200,
                                    width: 200,
                                    margin: '0 auto',
                                }}
                            />
                            <span style={{ color: 'grey' }}>
                                ¡Aun no hay tareas!
                            </span>
                        </div>
                    )}
                </>
            )}

            <UpdateTask
                modalVisible={modalVisible}
                closeModal={closeModal}
                rowData={rowData}
            />
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        tasks: state.GetTasks.tasks,
        loading: state.GetTasks.loading,
        taskCard: state.GetTasks.taskCard,
    };
};

const mapDispatchToProps = {
    getTasks,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskCard);
